import { Component, OnInit } from "@angular/core";
import { scrollToTop } from "src/app/helpers/helpers";
import { MetaService } from "src/app/services/meta.service";

@Component({
  selector: "app-for-customers",
  templateUrl: "./for-customers.component.html",
  styleUrls: ["./for-customers.component.scss"],
})
export class ForCustomersComponent implements OnInit {
  constructor(private metaService: MetaService) {}

  ngOnInit(): void {
    scrollToTop();

    this.metaService.set({
      title: "Kullanıcılar İçin - Bilgesin",
      description:
        "Üye olduktan sonra, sana özel ve en uygun anketler iletilecek.",
    });
  }
}
